var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 12.0028H4.4367C2.72203 12.0001 1.33203 10.6621 1.33203 9.01142C1.33203 7.36142 2.72203 6.02342 4.4367 6.02342C4.6987 4.84875 5.6327 3.89009 6.8867 3.50809C8.14003 3.12675 9.52403 3.37942 10.516 4.17475C11.508 4.96809 11.9574 6.17942 11.696 7.35409H12.356C13.276 7.35409 14.0714 7.89609 14.4427 8.68075M12.6654 10.6668V14.6668M12.6654 14.6668L14.6654 12.6668M12.6654 14.6668L10.6654 12.6668",
    stroke: "#00FFE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDark);
export default __webpack_public_path__ + "static/media/cloudDark.afd590b199b86e518dbc944b55dceab5.svg";
export { ForwardRef as ReactComponent };